import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Html from './html.vue'

// props
export const htmlProps = buildProps({
  // 值
  value: {
    type: String,
    default: '',
  },
  // 选项
  options: {
    type: definePropType<any>(Object),
    default: () => ({}),
  },
} as const)

// props
export type HtmlProps = ExtractPropTypes<typeof htmlProps>

// instance
export type HtmlInstance = InstanceType<typeof Html>
